import React from 'react';
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  useTheme
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const BottomNav = ({ activeComponent, onNavigate }) => {
  const theme = useTheme();

  // Add touch-start handler for Safari
  const handleTouchStart = (e, value) => {
    e.preventDefault();
    onNavigate(value);
  };

  // Add click handler as fallback
  const handleClick = (value) => {
    onNavigate(value);
  };

  const navigationItems = [
    { label: 'Market', value: 'marketwatch', icon: <ShowChartIcon /> },
    { label: 'Orders', value: 'orders', icon: <ListAltIcon /> },
    { label: 'Portfolio', value: 'portfolio', icon: <AccountBalanceWalletIcon /> },
    { label: 'Funds', value: 'funds', icon: <AccountBalanceIcon /> },
    { label: 'Support', value: 'support', icon: <SupportAgentIcon /> }
  ];

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000,
        borderTop: 1,
        borderColor: 'divider',
        background: '#0A1929',
        boxShadow: '0px -2px 4px rgba(0,0,0,0.1)',
        '-webkit-tap-highlight-color': 'transparent',
        '& *': {
          '-webkit-tap-highlight-color': 'transparent',
          'touch-action': 'manipulation'
        }
      }} 
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={activeComponent}
        sx={{
          height: 56,
          backgroundColor: 'transparent',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 0',
            color: 'rgba(255, 255, 255, 0.7)',
            transition: 'all 0.2s ease',
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              top: '-10px',
              bottom: '-10px',
              left: '-10px',
              right: '-10px',
            },
            '&.Mui-selected': {
              color: '#fff',
              '& .MuiSvgIcon-root': {
                transform: 'scale(1.1)',
                transition: 'transform 0.2s ease',
              }
            },
            '& .MuiSvgIcon-root': {
              transition: 'transform 0.2s ease',
              fontSize: '1.3rem',
            }
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.675rem',
            color: 'white !important',
            opacity: 0.7,
            transition: 'all 0.2s ease',
            '&.Mui-selected': {
              fontSize: '0.75rem',
              fontWeight: 600,
              opacity: 1,
              color: 'white !important'
            }
          }
        }}
      >
        {navigationItems.map((item) => (
          <div 
            key={item.value}
            onClick={() => handleClick(item.value)}
            onTouchStart={(e) => handleTouchStart(e, item.value)}
            role="button"
            aria-label={item.label}
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              WebkitUserSelect: 'none',
              userSelect: 'none',
              position: 'relative'
            }}
          >
            <BottomNavigationAction
              label={item.label}
              value={item.value}
              icon={item.icon}
              sx={{
                pointerEvents: 'none',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  transform: activeComponent === item.value ? 'translateX(-50%) scaleX(1)' : 'translateX(-50%) scaleX(0)',
                  width: '24px',
                  height: '2px',
                  borderRadius: '2px 2px 0 0',
                  backgroundColor: '#fff',
                  transition: 'transform 0.2s ease',
                },
                '&.Mui-selected': {
                  '& .MuiSvgIcon-root': {
                    color: '#fff',
                    transform: 'scale(1.1)',
                  },
                  '& .MuiBottomNavigationAction-label': {
                    color: '#fff !important',
                    fontWeight: 600
                  }
                }
              }}
            />
          </div>
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav; 